import React from 'react';
import './App.css';
import SignIn from "./containers/SignIn/SignIn";
import {Switch, Route, Redirect} from "react-router-dom";
import MainLayout from "./containers/MainLayout";
import ProtectedRoute from "./helper/ProtectedRoute";
import ErrorCodes from "./components/generic/error/errorCodes";

const App = () => {
    // check the 'user' credentials are existing or not
    if (localStorage.getItem('tmcUser') === null) {
        localStorage.setItem('tmcUser', JSON.stringify({
            isAuthenticated: false,
            mail: null,
            token: null,
            tokenExp: null,
            role: 'basic'
        }));
    }

    return (
        <Switch>
            <Route exact path="/login" render={props => {return <SignIn {...props} />}} />
            <ProtectedRoute path="/home" roles={['ROLE_USER','ROLE_ADMIN','ROLE_OPS','ROLE_CONSUMER','ROLE_PRODUCT_ADMIN']} component={MainLayout} />
            <Route exact path="/error" render={props => {return <ErrorCodes {...props} />}} />
            <Route render={() => <Redirect to={{pathname: "/login"}}/>}/>
        </Switch>
    );
};

export default App;
